import React, { useContext, useEffect } from "react";
import ParameterContext from "../../context/parameter/parameterContext";
import TradathonContext from "../../context/tradathon/TradathonContext";
import TradathonAddCoins from "../Tradathon/TradathonAddCoins";
import { formatPrice } from "../../helpers/format";
import Leaderboard from "../../components/Leaderboard/Leaderboard";
import BreadCrumbs from "../../components/BreadCrumbs";
import DummyLeaderboard from "../../components/Leaderboard/DummyLeaderboard";
import { socket_leaderboard } from "../../services/socket";
import cryptoContext from "../../context/crypto/cryptoContext";
import NumberFormat from "react-number-format";
import ReactTooltip from "react-tooltip";
import { FaInfoCircle } from "react-icons/fa";
import { useWindowSize } from "react-use";
const TradathonResult = ({ location, history }) => {
  const { setTradathonResultListingTab, tradathonResultListingTab } =
    useContext(ParameterContext);
  const {
    getLeaderboardOfContest,
    activeRoom,
    tradathonLoading,

    setLeaderboardOfContest,
    leaderboard,
    clearLeaderboard,
  } = useContext(TradathonContext);
  const { exchangeRate} = useContext(cryptoContext);
  const rid = location.search ? location.search.split("=")[2] : null;
  const { width } = useWindowSize();
  // const [leaderboard, setLeaderboard] = useState([]);

  useEffect(() => {
    clearLeaderboard();
    if (!activeRoom || !activeRoom.room) {
      history.push("/tradathon");
    } else {
      if (activeRoom.room.rstatus === 1) {
        socket_leaderboard.emit("leaderBoard", { rid: activeRoom.rid });

        socket_leaderboard.on("leaderBoardData", (data) => {
          setLeaderboardOfContest(
            data.sort((a, b) => b.totalPortfolioValue - a.totalPortfolioValue)
          );
        });
        var interval = setInterval(function () {
          socket_leaderboard.emit("leaderBoard", { rid: activeRoom.rid });
        }, 10000);
      } else {
        getLeaderboardOfContest(rid);
      }
      return () => clearInterval(interval);
    }
    //eslint-disable-next-line
  }, []);
  // useEffect(() => {
  //   if (tradathonResultListingTab === "winnings") {
  //     console.log("winnings");
  //     getWinnings(rid);
  //   }
  // }, [tradathonResultListingTab]);
  let routes = [];
  if (activeRoom && activeRoom.room) {
    routes = [
      { path: "/tradathon", name: "Tradathon" },

      {
        path: "/",
        name:
          activeRoom?.room?.rstatus === 2
            ? `Completed Contest (${activeRoom.room.rname})`
            : activeRoom?.room?.rstatus === 1
            ? `Live Contest (${activeRoom.room.rname})`
            : `Upcoming Contest (${activeRoom.room.rname})`,
      },
    ];
  }

  return activeRoom && activeRoom.room ? (
    <>
      <div className="Tradathon">
        <div className="Tradathon__container">
          {location.pathname.split("/").includes("room") && (
            <BreadCrumbs routes={routes} />
          )}
          <div className="Tradathon__listings">
            <div
              className="Favourite__tabs"
              id="favourite"
              style={{ margin: "10px 0" }}
            >
              {activeRoom.room.rstatus === 2 ? (
                <button
                  className={
                    tradathonResultListingTab === "Edit Portfolio"
                      ? "Favourite__exchange-tab"
                      : "Favourite__portfolio-tab"
                  }
                  onClick={() => setTradathonResultListingTab("Edit Portfolio")}
                >
                  My Portfolio
                </button>
              ) : (
                <button
                  className={
                    tradathonResultListingTab === "Edit Portfolio"
                      ? "Favourite__exchange-tab"
                      : "Favourite__portfolio-tab"
                  }
                  onClick={() => setTradathonResultListingTab("Edit Portfolio")}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    Edit Portfolio
                    {activeRoom.room.rstatus !== 0 && (
                      <>
                        <FaInfoCircle
                          size={16}
                          data-tip={`Total Spectators: ${
                            activeRoom.room.joinedMembers -
                            activeRoom.room.paidMembers
                          }`}
                        />
                        <ReactTooltip place="top" effect="float" />
                      </>
                    )}
                  </div>
                </button>
              )}
              <button
                className={
                  tradathonResultListingTab === "leaderboard"
                    ? "Favourite__exchange-tab"
                    : "Favourite__portfolio-tab"
                }
                onClick={() => setTradathonResultListingTab("leaderboard")}
              >
                Leaderboard
              </button>
              <button
                className={
                  tradathonResultListingTab === "winnings"
                    ? "Favourite__exchange-tab"
                    : "Favourite__portfolio-tab"
                }
                onClick={() => setTradathonResultListingTab("winnings")}
              >
                Winnings{" "}
                {activeRoom.room.rstatus === 0 && (
                  <>
                    <FaInfoCircle
                      size={16}
                      data-tip="winning amount and distribution<br />can change on start of contest<br />depending on joined members"
                      data-for="win"
                    />
                    <ReactTooltip
                      place={width > 900 ? "right" : "bottom"}
                      effect="float"
                      multiline={true}
                      id="win"
                    />
                  </>
                )}
              </button>
            </div>
          </div>

          <div
            className="Tradathon__listings__live"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr",
              gap: "20px",
            }}
          >
            {tradathonResultListingTab === "leaderboard" &&
              (tradathonLoading || !leaderboard || !leaderboard.length > 0 ? (
                <DummyLeaderboard />
              ) : leaderboard && leaderboard.length > 0 ? (
                leaderboard.map((d, index) => (
                  <Leaderboard
                    key={d._id ? d._id : d.rmid}
                    id={d.rmid}
                    username={d.userName}
                    netPL={formatPrice((d.totalPortfolioValue - 100000) / 1000)}
                    value={formatPrice(d.totalPortfolioValue)}
                    rank={index + 1}
                    avatar={d.avatar}
                  />
                ))
              ) : (
                <></>
              ))}
          </div>

          {tradathonResultListingTab === "winnings" && !tradathonLoading && (
            <center>
              <table
                className="Home__MainTable"
                style={{
                  marginTop: "10px",
                  background: "#EFF2F5",
                  width: "50%",
                }}
              >
                <thead>
                  <tr>
                    <th>
                      <div
                        className="Home__MainTable-th"
                        style={{ justifyContent: "center" }}
                      >
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          &nbsp;
                          <div style={{ cursor: "pointer" }}>Rank </div>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div
                        className="Home__MainTable-th"
                        style={{ justifyContent: "center" }}
                      >
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          &nbsp;
                          <div style={{ cursor: "pointer" }}>Winnings</div>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {activeRoom &&
                  activeRoom.room &&
                  activeRoom.room.winnings &&
                  activeRoom.room.winnings.length > 0 ? (
                    activeRoom.room.winnings.map((c, index) => (
                      <>
                        <tr key={index} className="Home__MainTable__link">
                          <td style={{ textAlign: "center" }}>{c.range}</td>

                          <td>
                            <div
                              className="Home__MainTable-td"
                              style={{ justifyContent: "center" }}
                            >
                              <p
                                style={{
                                  marginRight: "5px",
                                  whiteSpace: "nowrap",
                                  cursor: "pointer",
                                }}
                              >
                                <NumberFormat
                                  value={formatPrice(c.amt / exchangeRate)}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix="₹"
                                />
                              </p>
                            </div>
                          </td>
                        </tr>
                      </>
                    ))
                  ) : (
                    <></>
                  )}
                </tbody>
              </table>
            </center>
          )}
        </div>
      </div>

      {tradathonResultListingTab === "Edit Portfolio" && (
        <TradathonAddCoins location={location} history={history} />
      )}

      {/* {tradathonLoading&&<Loader/> } */}
    </>
  ) : (
    <></>
  );
};

export default TradathonResult;
